import React from 'react'
import classNames from 'classnames'

const ModalContent = ({ children, dialog }) => {
  return (
    <div className={classNames('modal-content', { '-dialog': dialog })}>
      {children}
    </div>
  )
}

export default ModalContent
